import React from "react";
import { DateRangePicker, DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { useResponsive } from "../../../../../hooks/useResponsive";
import { CustomButton } from "../../../../../components/Button/Button";
import { useMissingStatusDateFilter } from "../../hooks/useMissingStatusDateFilter";

const WorkflowDateRangeFilter = ({ onClose }) => {
  const isMobile = useResponsive("down", "md");
  const {
    selectionRange,
    handleSelect,
    submitSelection,
    resetSelection,
  } = useMissingStatusDateFilter(onClose);

  return (
    <div className="d-grid">
      {isMobile ? (
        <DateRange
          ranges={selectionRange}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          direction="horizontal"
        />
      ) : (
        <DateRangePicker
          ranges={selectionRange}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          direction="horizontal"
        />
      )}
      <div className={`d-flex ${isMobile ? "mt-2" : ""}`}>
        <CustomButton
          onClick={resetSelection}
          className="reset-date-picker  reset-btn">
          Reset
        </CustomButton>
        <CustomButton
          onClick={submitSelection}
          className="submit-date-picker"
          variant="contained">
          Submit
        </CustomButton>
      </div>
    </div>
  );
};

export default React.memo(WorkflowDateRangeFilter);
